import { BaseApi } from "./BaseApi";

export interface ConfiguracaoTelemetria {
    desempenho: boolean;
    reentrancia: boolean;
    bloquearReentrancia: boolean;
    coverage: boolean;
}

export class TelemetriaApi extends BaseApi {

    async obterStatus(): Promise<ConfiguracaoTelemetria> {
        const url = `/Telemetria/ObterStatus`;

        const resposta = await this.api.get(url);
        return resposta.data;
    }

    async verificarAtivacao(): Promise<boolean> {
        const url = `/Telemetria/TelemetriaAtivada`;

        const resposta = await this.api.get(url);
        return resposta.data;
    }

    async configurarParametros(config: ConfiguracaoTelemetria): Promise<boolean> {
        const url = `/Telemetria/ConfigurarParametros`;

        const resposta = await this.api.post(url, {
                desempenho: config.desempenho,
                reentrancia: config.reentrancia,
                bloquearReentrancia: config.bloquearReentrancia,
                coverage: config.coverage,
            });

        return resposta.status === 200;
    }

    async descarregarTelemetria(): Promise<boolean> {
        const url = `/Telemetria/DescarregarTelemetria`;
        const resposta = await this.api.post(url);

        return resposta.status === 200;
    }
}